"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));

var _react = _interopRequireDefault(require("react"));

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

var CustomPopper = function CustomPopper(props) {
  return /*#__PURE__*/_react["default"].createElement(_Popper["default"], (0, _extends2["default"])({}, props, {
    container: (0, _runtimeConfigHelper.getRuntimeConfig)().version === 2 ? document.querySelector('#content > div.' + (0, _runtimeConfigHelper.getRuntimeConfig)()._app) : document.body
  }));
};

var _default = CustomPopper;
exports["default"] = _default;